package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "ru")
val RuStrings = Strings(
    analyzer = "Анализатор",
    appreciationOverview = "Обзор удорожания",
    chartLegendInterest = "Проценты",
    chartLegendPrincipal = "Основной долг",
    chartXaxisMonths = "Месяцы",
    chartYaxisPayment = "Платеж",
    code = "ru",
    costOfCredit = "Стоимость кредита",
    creditDealAnalyzerDescription = "Введите данные вашего кредита, чтобы получить всесторонний анализ вашего кредитного предложения. Наш анализатор оценивает ключевые показатели, чтобы помочь вам понять реальную стоимость вашего кредита и принять обоснованное решение.",
    detailsGoodRateLongTerm = "Хорошая ставка, но длительный срок приводит к высокой общей стоимости.",
    detailsHighApr = "Высокая ПСК. ",
    detailsHighInterestCost = "Высокая общая стоимость процентов.",
    detailsHighRateShortTerm = "Высокая ставка, но короткий срок удерживает общую стоимость низкой.",
    detailsLowApr = "Низкая ПСК. ",
    detailsLowInterestCost = "Низкая общая стоимость процентов.",
    discountsTradeIn = "Скидки / Trade-in",
    displayName = "Русский",
    distribution = "Распределение",
    downPayment = "Первоначальный взнос",
    effectiveApr = "ПСК",
    headerBalance = "Остаток",
    headerDate = "Дата",
    headerInterest = "Проценты",
    headerMonth = "#",
    headerPayment = "Платеж",
    headerPrincipal = "Основной долг",
    hideDetails = "Скрыть детали",
    interest = "Проценты",
    invalidData = "Неверные данные",
    loanAmountSupportingText = "Полная сумма кредита, включая любые дополнительные расходы.",
    loanDetails = "Детали кредита",
    paymentSupportingText = "Ваш предполагаемый ежемесячный платеж.",
    paymentComposition = "Состав платежа",
    percentSymbol = "%",
    principal = "Основной долг",
    ratingBad = "Плохая сделка",
    ratingExcellent = "Отличная сделка",
    ratingFair = "Честная сделка",
    ratingGood = "Хорошая сделка",
    ratingPoor = "Слабая сделка",
    schedule = "График",
    showDetails = "Показать детали",
    summaryBad = "Очень невыгодно, избегайте, если возможно.",
    summaryExcellent = "Отличные финансовые условия.",
    summaryFair = "Честные условия, рассмотрите возможность переговоров.",
    summaryGood = "Хорошие условия, стандартные для рынка.",
    summaryPoor = "Плохие условия, высокая стоимость или ставка.",
    totalPaid = "Всего выплачено",
    lockTaxRate = "Заблокировать налоговую ставку",
    unlockTaxRate = "Разблокировать налоговую ставку",
    currencySymbol = "₽",
    currency = "Валюта",
    totalCreditAmount = "Общая сумма кредита",
    taxAmount = "Сумма налога/вычета",
    netAmountDisbursed = "Чистая сумма к выдаче",
    years = "Лет",
    loanTermTotalMonths = "Срок кредита (месяцев)",
    monthlyInstallment = "Ежемесячный платеж",
    principalInstallment = "Платеж по основному долгу",
    otherFees = "Другие сборы",
    insuranceCost = "Страховая премия",
    aprc = "Полная стоимость кредита (ПСК)",
    totalAmountPayable = "Общая сумма к выплате",
    prepaidFeeFixed = "Комиссия за оформление (фиксированная сумма)",
    prepaidFeePercentage = "Комиссия за оформление (процент)",
    months = "Месяцев",
    description = "Этот анализатор помогает вам оценить, выгодно ли для вас кредитное предложение. В отличие от стандартных калькуляторов, он не требует ввода процентной ставки. Вместо этого он рассчитывает ПСК и общую стоимость кредита на основе платежей и комиссий, предоставляя рейтинг сделки и подробные графики.",
    agree = "Согласен",
    information = "Информация",
    errorCalculationOverflow = "Годовая процентная ставка слишком высока, переполнение при вычислении.",
    errorTotalPaymentIsLessThanLoanAmount = "Полученная сумма меньше суммы кредита.",
    errorDivisionByZero = "Деление на ноль",
    errorNegativeResult = "Отрицательный результат",
    errorRateTooHigh = "Слишком высокая ставка",
    errorCalculation = "Пожалуйста, введите правильные данные",
    close = "Закрыть",

    hi = "Привет",
    guest = "Гость",
    account = "Аккаунт",
    signInWithGoogle = "Войти через Google",
    signOut = "Выйти",
    settings = "Настройки",
    about = "О приложении",
    privacyPolicy = "Политика конфиденциальности",
    termsOfService = "Условия использования",
    language = "Язык",

    theme = "Тема",
    light = "Светлая",
    dark = "Темная",
    system = "Системная",
    toggleExpand = "Развернуть/Свернуть",
)
